import {Component, Input, OnInit} from '@angular/core';

import {LpFundListItemReqRes} from '../../funds/LpFundListItemReqRes.model';
import {LpAssetListItemReqRes} from '../../assets/LpAssetListItemReqRes.model';
import {RoutingService} from '../../../services/routing.service';
import {UserService} from 'src/app/services/shared/user.service';
import {map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

@Component({
  selector: 'terra-lp-holdings-cards',
  templateUrl: './lp-holdings-cards.component.html',
  styleUrls: ['./lp-holdings-cards.component.scss']
})
export class LpHoldingsCardsComponent implements OnInit {
  @Input() funds: LpFundListItemReqRes[];
  @Input() assets: LpAssetListItemReqRes[];
  @Input() isOpportunity = false;
  @Input() showAddYourAssetCard = false;

  constructor(private routingService: RoutingService, private userService: UserService) {
  }

  ngOnInit(): void {
  }

  moreDetails(holdingId, opportunityId: string, isAsset: boolean, isOfferingDeck: boolean): string {
    if (this.isOpportunity) {
      if (isOfferingDeck) {
        return this.routingService.lpOfferingDeck(opportunityId);
      } else {
        return this.routingService.lpOpportunityCampaign(opportunityId, holdingId);
      }
    } else if (isAsset) {
      return this.routingService.lpAsset(holdingId);
    } else {
      return this.routingService.lpFund(holdingId);
    }
  }

  getMoreDetailsQueryParams(isOfferingDeck: boolean): Observable<any> {
    if (this.isOpportunity && isOfferingDeck) {
      return this.userService.accountDetails$.pipe(map(details => ({email: details.email})));
    }
    return of();
  }
}
